// SPDX-License-Identifier: AGPL-3.0-or-later

import styles from '@app/features/channel/components/EmojiPicker.module.css';
import type {GuildSticker} from '@app/features/expressions/models/GuildSticker';
import {GuildIcon} from '@app/features/guild/components/popouts/GuildIcon';
import Guilds from '@app/features/guild/state/Guilds';
import {Scroller} from '@app/features/ui/components/Scroller';
import {Tooltip} from '@app/features/ui/tooltip/Tooltip';
import {clsx} from 'clsx';
import {observer} from 'mobx-react-lite';

interface StickerPickerCategoryListProps {
	stickersByGuildId: ReadonlyMap<string, ReadonlyArray<GuildSticker>>;
	handleCategoryClick: (category: string) => void;
	horizontal?: boolean;
}
export const StickerPickerCategoryList = observer(
	({stickersByGuildId, handleCategoryClick, horizontal = false}: StickerPickerCategoryListProps) => {
		if (horizontal) {
			return (
				<div className={styles.horizontalCategories}>
					{Array.from(stickersByGuildId.keys()).map((guildId) => {
						const guild = Guilds.getGuild(guildId)!;
						return (
							<button
								key={guild.id}
								type="button"
								onClick={() => handleCategoryClick(guild.id)}
								className={clsx(styles.categoryListIcon, styles.textPrimaryMuted)}
								aria-label={guild.name}
							>
								<GuildIcon id={guild.id} name={guild.name} icon={guild.icon} className={styles.iconSize} sizePx={24} />
							</button>
						);
					})}
				</div>
			);
		}
		return (
			<div className={styles.categoryList}>
				<Scroller
					className={styles.categoryListScroll}
					key="sticker-picker-category-list-scroller"
					fade={false}
					showTrack={false}
				>
					<div className={styles.listItems}>
						{Array.from(stickersByGuildId.keys()).map((guildId) => {
							const guild = Guilds.getGuild(guildId)!;
							return (
								<Tooltip key={guild.id} text={guild.name} position="left">
									<button
										type="button"
										onClick={() => handleCategoryClick(guild.id)}
										className={clsx(styles.categoryListIcon, styles.textPrimaryMuted)}
									>
										<GuildIcon
											id={guild.id}
											name={guild.name}
											icon={guild.icon}
											className={styles.iconSize}
											sizePx={24}
										/>
									</button>
								</Tooltip>
							);
						})}
					</div>
				</Scroller>
			</div>
		);
	},
);
